import { type FC } from 'react';
import { BaseEdge, getStraightPath, type EdgeProps } from 'reactflow';
import type { LinkData } from '@/types/link.types';

const HIERARCHY_COLOR = '#1E293B';

export const HierarchyEdge: FC<EdgeProps<LinkData>> = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  markerEnd,
  style,
}) => {
  const [edgePath] = getStraightPath({ sourceX, sourceY, targetX, targetY });

  return (
    <BaseEdge
      id={id}
      path={edgePath}
      markerEnd={markerEnd}
      style={{
        stroke: HIERARCHY_COLOR,
        strokeWidth: 3,
        ...style,
      }}
    />
  );
};

export default HierarchyEdge;
